import { fabric } from 'fabric';

/** 画布外围（页面外）背景色 */
export const OUTSIDE_CANVAS_COLOR = '#1a1a1a';

const TILE_SIZE = 16;
const TILE_LIGHT = '#ffffff';
const TILE_DARK = '#dedcdc';

let cachedPattern = null;

export function createCheckerboardPattern() {
  if (cachedPattern) return cachedPattern;
  const tile = TILE_SIZE * 2;
  const el = document.createElement('canvas');
  el.width = tile;
  el.height = tile;
  const ctx = el.getContext('2d');
  if (ctx) {
    ctx.fillStyle = TILE_LIGHT;
    ctx.fillRect(0, 0, tile, tile);
    ctx.fillStyle = TILE_DARK;
    ctx.fillRect(0, 0, TILE_SIZE, TILE_SIZE);
    ctx.fillRect(TILE_SIZE, TILE_SIZE, TILE_SIZE, TILE_SIZE);
  }
  cachedPattern = new fabric.Pattern({ source: el, repeat: 'repeat' });
  return cachedPattern;
}

export function isCheckerboardFill(fill) {
  if (!fill || fill === 'transparent') return true;
  if (typeof fill === 'object' && fill.source) return true;
  return false;
}

export function isDefaultPageFill(fill) {
  if (isCheckerboardFill(fill)) return true;
  const normalized = String(fill).toLowerCase();
  return (
    normalized === '#ffffff'
    || normalized === '#fff'
    || normalized === 'white'
    || normalized === 'rgba(255,255,255,1)'
  );
}

export function resolveWorkspaceBgDisplay(fill) {
  if (isCheckerboardFill(fill)) return 'transparent';
  if (typeof fill === 'string') return fill;
  return 'transparent';
}

export function applyDefaultPageFill(workspace) {
  if (!workspace) return;
  workspace.set('fill', createCheckerboardPattern());
}
